// Colours for the Clock-In timer and Chart pages, which sit straight on the
// page background with no card behind them (Jade, 2026-10-24). Text, the ring
// and icons are black, or white on dark backgrounds (and dark mode), never the
// accent. The few buttons that need a surface get a frosted one.
import { isDarkBgTheme, ACTIVE_BG_THEME, isDarkMode } from "./colorEngine";

export function clockInInk() {
  const dark = isDarkBgTheme();
  // Default's white page: a white frosted button would vanish, so it gets a faint grey edge.
  const plain = !dark && ACTIVE_BG_THEME === "none" && !isDarkMode();
  return {
    dark,
    ink: dark ? "#ffffff" : "#111111",
    soft: dark ? "rgba(255,255,255,0.68)" : "rgba(17,17,17,0.6)",
    faint: dark ? "rgba(255,255,255,0.2)" : "rgba(0,0,0,0.13)",
    // Pill switch (Custom / Elapsed, Week / Month / Year): track + picked pill.
    track: dark ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.06)",
    pillOn: dark ? "rgba(255,255,255,0.22)" : "rgba(255,255,255,0.85)",
    glass: {
      background: dark ? "rgba(255,255,255,0.14)" : plain ? "rgba(255,255,255,0.6)" : "rgba(255,255,255,0.32)",
      border: `1px solid ${dark ? "rgba(255,255,255,0.35)" : plain ? "rgba(0,0,0,0.1)" : "rgba(255,255,255,0.7)"}`,
      backdropFilter: "blur(14px) saturate(1.4)",
      WebkitBackdropFilter: "blur(14px) saturate(1.4)",
      boxShadow: dark ? "0 4px 18px rgba(0,0,0,0.18)" : "0 4px 18px rgba(0,0,0,0.06)",
    },
  };
}

// Text button beside the top bar's menu button: Custom / Elapsed on the timer page,
// the Week / Month / Year dropdown on the Chart page. Same type as the Planner list
// view's "All Items" dropdown (Jade, 2026-10-24).
export const ciTitleBtn = (ci) => ({
  display: "inline-flex", alignItems: "center", gap: 6, marginRight: "auto", minHeight: 0, minWidth: 0,
  height: 40, padding: 0, border: "none", background: "none", cursor: "pointer", flexShrink: 0,
  color: ci.ink, fontFamily: "'Nunito', sans-serif", fontSize: 17, fontWeight: 800, whiteSpace: "nowrap",
});

// A sliding sheet over a blurred element makes the phone re-blur it every frame
// (see navBlur / no-nav-blur), so the frosted buttons drop their blur while one is open.
if (typeof document !== "undefined" && !document.getElementById("ci-glass-css")) {
  const st = document.createElement("style");
  st.id = "ci-glass-css";
  st.textContent = "html:has(.no-nav-blur) .ci-glass { backdrop-filter: none !important; -webkit-backdrop-filter: none !important; }"
    // Desktop: the page starts after the 72px side bar (App.jsx), so pull the Clock-In
    // timer / Chart back by half of it to sit in the middle of the screen (Jade, 2026-10-24).
    + " @media (min-width: 1024px) { .ci-desk-center { position: relative; left: -36px; } }";
  document.head.appendChild(st);
}
